document.addEventListener("DOMContentLoaded", function() {
    // Define the interaction handler
    function triggerUnblock() {
        if (window.yett && typeof window.yett.unblock === 'function') {
            window.yett.unblock('/gp/', '/onsite/', '/cdn.judge.me/', '/shopify_chat/,/shop-js/,/store-front/');
        }
        
        // Clean up listeners immediately so they only run once
        window.removeEventListener('mousemove', triggerUnblock);
        window.removeEventListener('touchstart', triggerUnblock);
        window.removeEventListener('wheel', triggerUnblock);
    }

    // Add native event listeners for user interaction
    window.addEventListener('mousemove', triggerUnblock);
    window.addEventListener('touchstart', triggerUnblock);
    window.addEventListener('wheel', triggerUnblock, { passive: true });
});